import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';
import { ProjectMember } from './project-member';

export class MemberCloudFile {
    private coords: CoordinatorService;
    private _remoteHash?: string;
    private _localHash?: string;
    private _remoteModified?: Temporal.Instant;
    private _remotePath?: string;

    private _uploadProblem?: {
        dH: FileSystemDirectoryHandle;
        fH: FileSystemFileHandle;
    };

    type: string;
    size?: number;

    private _isDownloading = false;

    // private _inQueue = false

    constructor(
        private pm: ProjectMember,
        public id: string,
    ) {
        this.coords = pm.coords;
        this.type = this.id.substring(0, this.id.indexOf('_'));
    }

    setUploadProblem({ dH, fH }: { dH: FileSystemDirectoryHandle; fH: FileSystemFileHandle }) {
        this._uploadProblem = { dH: dH, fH: fH };
    }

    private async _resolveUploadProblem() {
        this.coords.manifest$.post(
            'resolve-upload-problem',
            Object.assign({ projectId: this.pm.projectId }, this._uploadProblem!),
        );
        await this.coords.utils$.wait(1);
        this._uploadProblem = undefined;
    }

    async synchronize() {
        if (this._uploadProblem) {
            await this._resolveUploadProblem();
            return;
        }
        if (this._localHash === this._remoteHash) return;

        console.log('SYNCHRONIZE ', this.id);
        return await this.download();
    }

    async _saveLocal(blob: Blob) {
        try {
            if (this._localHash) {
                this.pm.deleteLocalFile(`.hash_${this.id}_${this._localHash}`);
            }

            // const bH = await this.pm.getLocalFileHandle(this.id);
            await this.coords.utils$.writeToDisk(`${this.pm.localFilepath}/${this.id}`, blob);

            // const hashH = await this.pm.getLocalFileHandle(`.hash_${this.id}_${this._remoteHash}`);
            await this.coords.utils$.writeToDisk(`${this.pm.localFilepath}/.hash_${this.id}_${this._remoteHash}`, '');

            this._localHash = this._remoteHash;
            this.pm.afterCloudDownload(this);
            console.log('SAVED LOCAL', this.id);
        } catch (e) {
            console.error('Save Local Failed', e);
        }
    }

    get remotePath() {
        if (!this._remotePath) {
            const prefix = `userdata/${this.pm.id}/projects/${this.pm.projectId}`;
            this._remotePath = `${prefix}/${this.id}`;
        }
        return this._remotePath;
    }

    setHash(h: string) {
        this._remoteHash = h;
    }

    setLocalHash(h: string) {
        this._localHash = h;
    }

    getHash() {
        return this._remoteHash;
    }

    updateFromCloudData(params: any) {
        this._remoteHash = params.hash;
        this._remotePath = params.remotePath;
        this.size = params.size;
        try {
            if (params.timestamp)
                this._remoteModified = Temporal.Instant.fromEpochSeconds(params.timestamp.seconds);
        } catch (e) {
            console.log('updateFromCloudData', params, e);
        }
    }

    get remoteEpochModified() {
        return this._remoteModified?.epochMilliseconds || 0;
    }

    async delete() {
        const resp = await this.coords.firebase$.storage.deleteFile(this._remotePath!);
        const resp2 = await this.coords.firebase$.firestore.deleteDocument(
            'storage',
            this._remotePath!,
        );
    }

    async download() {
        if (!this._remotePath) return console.error('No Remote Path', this);

        this._isDownloading = true;
        try {
            const resp = await this.coords.firebase$.storage.downloadFile2(this._remotePath);
            if (resp) await this._saveLocal(resp);
            else console.error('Download Failed', this);
        } finally {
            this._isDownloading = false;
        }
    }

    get isDownloading() {
        return this._isDownloading;
    }

    print() {
        console.log(this._remotePath, this._remoteHash, this._localHash);
    }
}
